module.exports = __webpack_public_path__ + "img/eu.e04f5ca9.png";